import * as Handlebars from 'handlebars/dist/handlebars.js';

Handlebars.registerHelper('math', (lvalue, operator, rvalue, options) => {
  const leftValue = parseFloat(lvalue);
  const rightValue = parseFloat(rvalue);
  return {
    '+': leftValue + rightValue,
    '-': leftValue - rightValue,
    '*': leftValue * rightValue,
    '/': leftValue / rightValue,
    '%': leftValue % rightValue
  }[operator];
});

Handlebars.registerHelper('getTimeSlot', (TimeSlot, options) => {
  const text = TimeSlot.split('-');
  return (`${text[0].replace(/\s/g, '')} - ${text[1].replace(/\s/g, '')}`).toLowerCase();
});

Handlebars.registerHelper('showMinimumAge', (age, options) => {
  return Number(age) === 0 ? 'No Minimum Age' : `Must be +${age} years old`;
});

Handlebars.registerHelper('removeHtmlTags', (content, options) => {
  // adding span so it will work for normal string also
  return $(`<span>${content}</span>`).text();
});

Handlebars.registerHelper('createImageURL', (imageUrl, options) => {
  if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
    return `${imageUrl}?w=361&h=235`;
  }
  return `${imageUrl}&w=361&h=235`;
});

Handlebars.registerHelper('createProductCartImageURL', (imageUrl, options) => {
  if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
    return `${imageUrl}?w=224&h=128`;
  }
  return `${imageUrl}&w=224&h=128`;
});

Handlebars.registerHelper('addVibeProductURL', (vibeProductType, productUrl, variantId, options) => {
  let VibeProductURL = productUrl;
  if (vibeProductType === 'EX') {
    VibeProductURL = `${VibeProductURL}?selectedVariant=${variantId}`;
  }
  return VibeProductURL;
});

Handlebars.registerHelper('addStartingFrom', (category, hasVariant, options) => {
  let returnValue = '';
  if (category !== 'Bottomless Bubbles Package' && hasVariant === 'true') {
    returnValue = 'Starting From';
  }
  return returnValue;
});
Handlebars.registerHelper('perPersonCond', (vibeProductType, perSalesDescription, options) => {
  let returnValue = '';
  if (vibeProductType !== 'SP' && perSalesDescription !== '' && perSalesDescription !== null) {
    returnValue = `/ ${perSalesDescription}`;
  }
  return returnValue;
});

Handlebars.registerHelper('encryptedIdDisplay', (displayBookingId, bookingId, options) => {
  let returnValue = '';
  if (displayBookingId) {
    returnValue = displayBookingId;
  } else {
    returnValue = bookingId;
  }
  return returnValue;
});

Handlebars.registerHelper('availableTickets', (tickets, options) => {
  const ticketText = Number(tickets) > 1 ? 'Tickets' : 'Ticket';
  return `${tickets} ${ticketText} Available`;
});

Handlebars.registerHelper('ccl_if_eq', (a, b, opts) => {
  if (a === b) {
    return opts.fn(this);
  }
  return opts.inverse(this);
});
Handlebars.registerHelper('calc', (lvalue, operator, rvalue, options) => {
  console.log('operation:', operator);
  const lval = parseInt(lvalue, 10);
  const rval = parseInt(rvalue, 10);
  return {
    '+': lval + rval,
    '-': lval - rval,
    '*': lval * rval,
    '/': lval / rval,
    '%': lval % rval
  }[operator];
});
Handlebars.registerHelper('ifCond', (v1, operator, v2, options) => {
  switch (operator) {
    case '===':
      return (v1 === v2) ? options.fn(this) : options.inverse(this);
    case '!==':
      return (v1 !== v2) ? options.fn(this) : options.inverse(this);
    case '<':
      return (v1 < v2) ? options.fn(this) : options.inverse(this);
    case '<=':
      return (v1 <= v2) ? options.fn(this) : options.inverse(this);
    case '>':
      return (v1 > v2) ? options.fn(this) : options.inverse(this);
    case '>=':
      return (v1 >= v2) ? options.fn(this) : options.inverse(this);
    case '&&':
      return (v1 && v2) ? options.fn(this) : options.inverse(this);
    case '||':
      return (v1 || v2) ? options.fn(this) : options.inverse(this);
    default:
      return options.inverse(this);
  }
});

Handlebars.registerHelper('checkIf', (v1, o1, v2, mainOperator, v3, o2, v4, options) => {
  const operators = {
    '===': (a, b) => { return a === b; },
    '!==': (a, b) => { return a !== b; },
    '<': (a, b) => { return a < b; },
    '<=': (a, b) => { return a <= b; },
    '>': (a, b) => { return a > b; },
    '>=': (a, b) => { return a >= b; },
    '&&': (a, b) => { return a && b; },
    '||': (a, b) => { return a || b; }
  };
  const a1 = operators[o1](v1, v2);
  const a2 = operators[o2](v3, v4);
  const isTrue = operators[mainOperator](a1, a2);
  return isTrue ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ccl_or', (v1, v2, options) => {
  if (v1 || v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper('removeSpace', (value, options) => {
  return value ? value.replace(/[^A-Z0-9]+/ig, '_') : '';
});

Handlebars.registerHelper('firstLetterCapital', (value, options) => {
  let newValue = value;
  if (value) {
    const firstChartext = value.slice(0, 1).toUpperCase();
    const remainingText = value.slice(1);
    newValue = firstChartext.concat(remainingText);
  }

  return newValue;
});

Handlebars.registerHelper('addPipeSeperator', (audultPrice, childPrice, options) => {
  let returnValue = '';
  if (audultPrice && childPrice) {
    returnValue = '|';
  }
  return returnValue;
});



// WEBPACK FOOTER //
// ./src/js/htmlHelpers.js